import React from 'react';
import Htmllogo from '../images/html.png';
import CSS from '../images/csslogo.png';
import Javascriptlogo from '../images/js.png';
import Reactjslogo from '../images/reactlogo.png';
import Anjularlogo from '../images/Anjularlogo.png';
import Uvjslogo from '../images/uvjs.png';
import MobileLogo from '../images/mobile.png';
import TabletsLogo from '../images/Tablets.png';
import Desktoplogo from '../images/Desktoplogo.png';
import Scsslogo from '../images/Scsslogo.png';
import Less from '../images/Less.png';
import Postcss from '../images/Postcss.png';
import Nodejs from '../images/Nodejs.png';
import DjPych from '../images/DjPych.png';
import SpringBoost from '../images/SpringBoost.png';
import Laravel from '../images/Laravel.png';
import MySql from '../images/MySql.png';
import PostSql from '../images/PostSql.png';
import MongoDB from '../images/MongoDB.png';
import FireBase from '../images/FireBase.png';
import COcrokDB from '../images/COcrokDB.png';
import ReactNative from '../images/ReactNative.png';
import AndriodStudio from '../images/AndriodStudio.png';
import Swift from '../images/Swift.png';
import Flutter from '../images/Flutter.png';
import Adobe from '../images/Adobe.png';
import Figma from '../images/Figma.png';
import './css/ourtechnologies.css'
import { Link } from 'react-router-dom';


function Ourtechnologies() {
  return (
    <div>

      <br /> <br /> <br />

      <h1>Platforms and Technology</h1>
      <h3>The technologies we use to build apps</h3>

      <h2 className='center'>Frontend Technologies</h2>
      <div className='flex-ourtechnologies'>
        <div className='flex-ourtechnologies-images'>
          <img src={Htmllogo} alt='htmllogo' />
          <p>HTML</p>
        </div>
        <div className='flex-ourtechnologies-images'>
          <img src={CSS} alt='csslogo' />
          <p>CSS</p>
        </div>
        <div className='flex-ourtechnologies-images'>
          <img src={Javascriptlogo} alt='jslogo' />
          <p>JAVASCRIPT</p>
        </div>
      </div>

      <br />
      <h2 className='center'>Frontend Frameworks</h2>
      <div className='flex-ourtechnologies'>
        <div className='flex-ourtechnologies-images'>
          <img src={Reactjslogo} alt='reactlogo' />
          <p>React.js</p>
        </div>
        <div className='flex-ourtechnologies-images'>
          <img src={Anjularlogo} alt='angularlogo' />
          <p>Angular.js</p>
        </div>
        <div className='flex-ourtechnologies-images'>
          <img src={Uvjslogo} alt='vuejslogo' />
          <p>Vue.js</p>
        </div>
      </div>

      <br />
      <h2 className='center'>Responsive Design</h2>
      <div className='flex-ourtechnologies'>
        <div className='flex-ourtechnologies-images'>
          <img src={MobileLogo} alt='mobilelogo' />
          <p>Mobile Design</p>
        </div>
        <div className='flex-ourtechnologies-images'>
          <img src={TabletsLogo} alt='tabletslogo' />
          <p>Tablets Design</p>
        </div>
        <div className='flex-ourtechnologies-images'>
          <img src={Desktoplogo} alt='desktoplogo' />
          <p>Desktop Design</p>
        </div>
      </div>

      <br />
      <h2 className='center'>CSS Preprocessors and Postprocessors</h2>
      <div className='flex-ourtechnologies'>
        <div className='flex-ourtechnologies-images'>
          <img src={Scsslogo} alt='scsslogo' />
          <p>SASS</p>
        </div>
        <div className='flex-ourtechnologies-images'>
          <img src={Less} alt='lesslogo' />
          <p>LESS</p>
        </div>
        <div className='flex-ourtechnologies-images'>
          <img src={Postcss} alt='postcsslogo' />
          <p>PostCSS</p>
        </div>
      </div>

      <br />
      <h2 className='center'>Backend Technologies</h2>
      <div className='flex-ourtechnologies'>
        <div className='flex-ourtechnologies-images'>
          <img src={Nodejs} alt='nodejslogo' />
          <p>Node.js</p>
        </div>
        <div className='flex-ourtechnologies-images'>
          <img src={DjPych} alt='django' />
          <p>Django</p>
        </div>
        <div className='flex-ourtechnologies-images'>
          <img src={SpringBoost} alt='springboot' />
          <p>Spring Boot</p>
        </div>
        <div className='flex-ourtechnologies-images'>
          <img src={Laravel} alt='laravel' />
          <p>Laravel</p>
        </div>
      </div>

      <br />
      <h2 className='center'>Databases</h2>
      <div className='flex-ourtechnologies'>
        <div className='flex-ourtechnologies-images'>
          <img src={MySql} alt='mysql' />
          <p>MySQL</p>
        </div>
        <div className='flex-ourtechnologies-images'>
          <img src={PostSql} alt='postgresql' />
          <p>PostgreSQL</p>
        </div>
        <div className='flex-ourtechnologies-images'>
          <img src={MongoDB} alt='mongodb' />
          <p>MongoDB</p>
        </div>
        <div className='flex-ourtechnologies-images'>
          <img src={FireBase} alt='firebase' />
          <p>Firebase</p>
        </div>
        <div className='flex-ourtechnologies-images'>
          <img src={COcrokDB} alt='cockroachdb' />
          <p>CockroachDB</p>
        </div>
      </div>

      <br />
      <h2 className='center'>Mobility</h2>
      <div className='flex-ourtechnologies'>
        <div className='flex-ourtechnologies-images'>
          <img src={ReactNative} alt='reactnative' />
          <p>React Native</p>
        </div>
        <div className='flex-ourtechnologies-images'>
          <img src={AndriodStudio} alt='androidstudio' />
          <p>Android Studio</p>
        </div>
        <div className='flex-ourtechnologies-images'>
          <img src={Swift} alt='swift' />
          <p>Swift</p>
        </div>
        <div className='flex-ourtechnologies-images'>
          <img src={Flutter} alt='flutter' />
          <p>Flutter</p>
        </div>
      </div>

      <br />
      <h2 className='center'>Prototypes, Illustrations, Designs and Animations</h2>
      <div className='flex-ourtechnologies'>
        <div className='flex-ourtechnologies-images'>
          <img src={Adobe} alt='adobe' />
          <p>Photoshop</p>
        </div>
        <div className='flex-ourtechnologies-images'>
          <img src={Figma} alt='figma' />
          <p>Figma</p>
        </div>
        <div className='flex-ourtechnologies-images'>
          <p>And many more....</p>
        </div>
      </div>

      <br/>
      <br/><center>
     <Link to='/contact'>  <button class="button-27">Contact us</button>  </Link>
      </center>
      <h5 className='center'> mailtovikasdoddamani@gmail.com  <br/>
      Whats app:
   +91-888-4707-098 </h5>
      <br/>      <br/>
      </div>
  );
}

export default Ourtechnologies;
